// var list = $(".produtint__desc");
// if (list.height() > 550) {
// 	list.addClass("expand closed");
// }

// list.css("height", "auto");
// var listheight = list.css("height");
// list.css("height", "550px");

// $(".more-less").on("click", function() {
// 	list.toggleClass("open closed");
//   if (list.hasClass("open")) {
//     list.height(listheight);
//   }
//   if (list.hasClass("closed")) {
//     list.height(550);
//   }
// });

var list = $(".produtint__desc");
var windowWidth = window.innerWidth;
var maxHeight;

// Define a altura máxima com base no tamanho da janela
if (windowWidth >= 992) { // lg e xl
  maxHeight = 550;
} else { // md, sm, xs
  maxHeight = 200; // Defina a altura desejada para mobile
}

// Verifica se precisa aplicar classes baseadas na altura real
if (list.height() > maxHeight) {
  list.addClass("expand closed");
}

list.css("height", "auto");
var listheight = list.css("height"); // altura natural (com tudo expandido)
list.css("height", maxHeight + "px");

$(".more-less").on("click", function() {
  list.toggleClass("open closed");

  if (list.hasClass("open")) {
    list.height(listheight);
  }
  if (list.hasClass("closed")) {
    list.height(maxHeight);
  }
});
